import { render } from "./AttachmentItem.vue?vue&type=template&id=1b850518&scoped=true"
import script from "./AttachmentItem.vue?vue&type=script&lang=js"
export * from "./AttachmentItem.vue?vue&type=script&lang=js"

import "./AttachmentItem.vue?vue&type=style&index=0&id=1b850518&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b850518"]])

export default __exports__